import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'undermaintanence',
  },
  {
    path: '/undermaintanence',
    name: 'under-maintanence',
    component: () => import('@/views/UnderMaintanence.vue'),
    meta: {
      layout: 'blank',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'under-maintanence') {
    return next({ name: 'under-maintanence' }) // Redirect to under-maintanence page
  }
  next()
})

export default router
